import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { BenchmarkType, EcosystemType, PlotReportFactElement } from '@/api/rest/resources/types/fact';
import { BenchmarkPill } from '@/components/Pill/BenchmarkPill';
import { useBenchmarkForFact } from '@/pages/shared/hooks/useBenchmarkForFact';
import { assertBenchmarkType } from '@/utils/assert';

export const EiiStatsTile = ({
  latestFact,
  benchmarks,
  eiiType = EcosystemType.terrestrial,
}: {
  latestFact: PlotReportFactElement<number>;
  benchmarks: (number | null | undefined)[];
  eiiType: EcosystemType;
}) => {
  const { t } = useTranslation();
  const benchmark = useBenchmarkForFact(benchmarks, latestFact.value, [
    BenchmarkType.very_low,
    BenchmarkType.low,
    BenchmarkType.moderate,
    BenchmarkType.high,
  ]);

  if (!benchmark) {
    return null;
  }

  assertBenchmarkType(benchmark, 'EiiStatsTile', BenchmarkType.unchanged);
  assertBenchmarkType(benchmark, 'EiiStatsTile', BenchmarkType.stable);
  assertBenchmarkType(benchmark, 'EiiStatsTile', BenchmarkType.alerted);
  assertBenchmarkType(benchmark, 'EiiStatsTile', BenchmarkType.very_high);

  return (
    <Stack className='justify-center gap-8 p-6 lg:gap-4 lg:p-8 lg:pr-2' data-testid='eii-stats-tile'>
      <Stack className='mt-4 gap-4 rounded-2xl bg-neutral-black-4 px-4 py-6'>
        {benchmark && <BenchmarkPill benchmarkType={benchmark} />}
        <span className='typography-body1Bold'>
          {t('shared.ncaDetail.details.ecosystemIntegrityIndex.explainers.whatDoesThisMean.title')}
        </span>
        <span className='typography-body1'>
          {t(
            `shared.ncaDetail.details.ecosystemIntegrityIndex.explainers.whatDoesThisMean.body.${eiiType}.${benchmark}`,
          )}
        </span>
      </Stack>
    </Stack>
  );
};
